import { salesTax } from './salesTax.type';

export enum FinancialConfigType {
  TAX = 'tax',
  DISCOUNT = 'discount',
  SERVICE_CHARGE = 'service_charges',
}

export interface RestaurantFinancialConfiguration {
  id: number;
  restaurantId: number | null;
  configType: FinancialConfigType;
  isTaxInclusive: boolean;
  createdAt: Date;
  updatedAt: Date;
  taxConfigurations: salesTax[];
}
